/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentAccessLogResponseDto } from '../../models/document-access-log-response-dto';

export interface DocumentAccessLogControllerGetAuditTrail$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Start date for audit period (Unix timestamp)
 */
  startDate?: number;

/**
 * End date for audit period (Unix timestamp)
 */
  endDate?: number;

/**
 * Filter by specific document ID
 */
  documentId?: string;

/**
 * Filter by specific patient ID
 */
  patientId?: string;

/**
 * Filter by specific user ID
 */
  userId?: string;
}

export function documentAccessLogControllerGetAuditTrail(http: HttpClient, rootUrl: string, params: DocumentAccessLogControllerGetAuditTrail$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentAccessLogResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, documentAccessLogControllerGetAuditTrail.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
    rb.query('documentId', params.documentId, {});
    rb.query('patientId', params.patientId, {});
    rb.query('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentAccessLogResponseDto>>;
    })
  );
}

documentAccessLogControllerGetAuditTrail.PATH = '/thalea-documents/access-logs/{tenant}/audit';
